import aesReduxConstants from '../../constants';

const userContextReducer = function() {
  const defaultState = {
    inSwitchContext: false,

    // user context switching
    userId: null,

    // user logged ins client id
    userClientId: null,

    // the client your looking at
    clientId: null,
  };

  const reducer = function(state, action) {
    const __constants = aesReduxConstants;

    if (state === undefined) state = defaultState;

    let delta = {};
    switch (action.type) {
      case __constants.SET_USER_CONTEXT:
        delta = {
          inSwitchContext: action.context.clientId !== action.context.userClientId,
          userId: action.context.userId,
          userClientId: action.context.userClientId,
          clientId: action.context.clientId,
        };
        break;
      default:
        return state;
    }

    return Object.assign({}, state, delta);
  };

  return reducer;
};

export default userContextReducer();
